import React, { FC } from 'react';
import { Box, Button, Flex, Icon } from '@qga/roo-ui/components';
import { DateRangeRenderProps } from '../../types';
import { PositionedButton } from '../primitives';

export const MobileLayout: FC<DateRangeRenderProps> = ({ children, ...rest }) => {
  return (
    <Box position="fixed" top="0" left="0" height="100%" width="100%" bg="greys.porcelain">
      <Flex bg="white" height="60px" fontSize="xl" justifyContent="center" alignItems="center" marginBottom="4">
        Select dates
      </Flex>

      <PositionedButton aria-label="Close" position="fixed" top="0" right="0" height="60px" width="60px" {...rest.getCancelProps()}>
        <Icon name="close" />
      </PositionedButton>

      {children}

      <Box position="fixed" bottom="0" left="0" right="0" bg="white" p="2" boxShadow="footer">
        <Button variant="primary" block {...rest.getDoneProps()}>
          Apply
        </Button>
      </Box>
    </Box>
  );
};
